module.exports = __webpack_public_path__ + "img/-LV18hw4-l8wKexbm96b.c5db5a85.jpg";